import { Button, InputBase, Typography, Box } from '@mui/material';
import ContentCopyIcon from '@mui/icons-material/ContentCopy';
import CheckIcon from '@mui/icons-material/Check';
import { styles } from './styles.ts';

type TLinkButtonProps = {
  linkUrl: string;
  text: string;
  isCopied: boolean;
  onCopyClick: () => void;
};

const LinkButton = ({ linkUrl, text, isCopied, onCopyClick }: TLinkButtonProps) => {
  return (
    <Box sx={styles.container}>
      <Box sx={styles.inputWrapper}>
        <InputBase value={linkUrl} readOnly sx={styles.input} />
      </Box>
      <Button
        variant="text"
        onClick={onCopyClick}
        sx={styles.copyButton}
        startIcon={isCopied ? <CheckIcon sx={styles.icon} /> : <ContentCopyIcon sx={styles.icon} />}
      >
        <Typography component="span" sx={styles.copyButtonText}>
          {isCopied ? 'Скопійовано!' : text}
        </Typography>
      </Button>
    </Box>
  );
};

export default LinkButton;
